// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"8c1c31fd","150":"0f52dc10","381":"7ee0bf77"}[chunkId] + ".chunk.css";
};